var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccountIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04004 11C2.04004 6.04998 6.05004 2.03998 11 2.03998C15.95 2.03998 19.96 6.04998 19.96 11C19.96 13.43 19 15.63 17.43 17.24C15.35 16.99 13.94 15.33 13.52 13.68C14.91 12.83 15.83 11.3 15.83 9.54998C15.83 6.87998 13.67 4.71998 11 4.71998C8.33004 4.71998 6.17004 6.87998 6.17004 9.54998C6.17004 11.3 7.10004 12.83 8.48004 13.68C8.06004 15.33 6.65004 16.99 4.57004 17.24C3.00004 15.63 2.04004 13.43 2.04004 11ZM6.54004 18.77C7.85004 19.53 9.38004 19.96 11 19.96C12.62 19.96 14.15 19.53 15.46 18.77C13.47 17.93 12.15 16.15 11.64 14.35C11.43 14.38 11.22 14.39 11 14.39C10.78 14.39 10.57 14.38 10.36 14.35C9.85004 16.15 8.53004 17.94 6.54004 18.77ZM11 0.039978C4.95004 0.039978 0.0400391 4.94998 0.0400391 11C0.0400391 17.05 4.95004 21.96 11 21.96C17.05 21.96 21.96 17.05 21.96 11C21.96 4.94998 17.05 0.039978 11 0.039978ZM11 6.71998C9.43004 6.71998 8.17004 7.98998 8.17004 9.54998C8.17004 11.12 9.44004 12.38 11 12.38C12.57 12.38 13.83 11.11 13.83 9.54998C13.84 7.98998 12.57 6.71998 11 6.71998Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountIcon);
export default __webpack_public_path__ + "static/media/accountIcon.53735f4d8f94c46dc588b44aab31586b.svg";
export { ForwardRef as ReactComponent };